export default {
  melhorEnvioEnabledIntegration: {},
};
